import { api } from '../http';

export const fetchRequiredDocuments = auctionId =>
  api.get(`/ofertasCompra/${auctionId}/requiredDocuments`);
export const addRequiredDocument = (auctionId, requiredDocument) =>
  api.post(`/ofertasCompra/${auctionId}/requiredDocuments`, requiredDocument);
export const removeRequiredDocument = (auctionId, requiredDocumentId) =>
  api.delete(`/ofertasCompra/${auctionId}/requiredDocuments/${requiredDocumentId}`);
